import * as React from 'react';
import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid2,
    MenuItem,
    Stack,
    TextField,
    Toolbar,
    Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ModernNavbar from '../setup/ModernNavbar';
import Footer from '../setup/Footer';
import Loading from '../../BuiltInComponent/Loading';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import { getYear, getMonth } from '../../features/setup/useableSlice';
import { getUnits } from '../../features/AdminManagement/unitsSlice';
import { getEligibleAdvances, getSkipList, addSkip, setCustomDeduction, deleteSkip } from '../../features/AdminManagement/advanceSkipSlice';

export default function AdvanceDeductionSkip() {
    const dispatch = useDispatch();

    const { years, months } = useSelector((state) => state.ru);
    const { units } = useSelector((state) => state.units);
    const { eligible, skipList, isLoading } = useSelector((state) => state.advSkip);

    const [filter, setFilter] = React.useState({
        year: '',
        month: '',
        unitID: ''
    });
    const [selectedAdvance, setSelectedAdvance] = React.useState(null);
    const [deductionAmount, setDeductionAmount] = React.useState('');

    const eligibleColumns = [
        { fieldName: 'advID', cName: 'ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'advID', cName: 'Advance ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Employee', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'installments', cName: 'Installments', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'recovered_amount', cName: 'Recovered', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'balance_amount', cName: 'Balance', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'advDate', cName: 'Advance Date', textAlign: 'left', dType: 'date', status: 'en' },
        { fieldName: 'control', cName: 'Deduction Control', textAlign: 'center', width: 120, status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' }
    ];

    const skipColumns = [
        { fieldName: 'skipID', cName: 'ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'advID', cName: 'Advance ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Employee', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'installments', cName: 'Installments', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'monthTag', cName: 'Month', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'controlType', cName: 'Control', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'deductionAmount', cName: 'Deduct This Month', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'created_at', cName: 'Created', textAlign: 'left', dType: 'date', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: 50, status: 'dis' },
        { fieldName: 'delete', cName: 'Remove', textAlign: 'center', width: 50, status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' }
    ];

    React.useEffect(() => {
        dispatch(getYear());
        dispatch(getUnits());
    }, [dispatch]);

    const handleYearChange = (e) => {
        const year = e.target.value;
        setFilter((prev) => ({ ...prev, year, month: '' }));
        if (year) {
            dispatch(getMonth({ year }));
        }
    };

    const handleMonthChange = (e) => {
        setFilter((prev) => ({ ...prev, month: e.target.value }));
    };

    const handleUnitChange = (e) => {
        setFilter((prev) => ({ ...prev, unitID: e.target.value }));
    };

    const loadData = () => {
        if (!filter.year || !filter.month) {
            alert('Please select year and month.');
            return;
        }
        dispatch(getEligibleAdvances({ year: filter.year, month: filter.month, unitID: filter.unitID || undefined }));
        dispatch(getSkipList({ year: filter.year, month: filter.month }));
    };

    const openDeductionControl = (advID) => {
        const advance = eligible.find((item) => item.advID === advID);
        setSelectedAdvance(advance || null);
        setDeductionAmount('');
    };

    const onSkipClick = async () => {
        if (!selectedAdvance || !filter.year || !filter.month) return;
        await dispatch(addSkip({ advID: selectedAdvance.advID, year: filter.year, month: filter.month }));
        setSelectedAdvance(null);
        loadData();
    };

    const saveCustomDeduction = async () => {
        if (!selectedAdvance || !filter.year || !filter.month || Number(deductionAmount) <= 0) return;
        await dispatch(setCustomDeduction({ advID: selectedAdvance.advID, year: filter.year, month: filter.month, deductionAmount: Number(deductionAmount) }));
        setSelectedAdvance(null);
        loadData();
    };

    const onRemoveClick = async (skipID) => {
        await dispatch(deleteSkip(skipID));
        loadData();
    };

    return (
        <>
            <ModernNavbar />
            <Toolbar />
            <Container maxWidth="lg">
                <Box sx={{ backgroundColor: '#1E90FF', mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 28, fontWeight: 'bolder' }}>Loan / Advance Deduction Control</Typography>
                </Box>

                <Grid2 container spacing={2} sx={{ mb: 2 }}>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Year"
                            value={filter.year}
                            onChange={handleYearChange}
                            fullWidth
                            size="small"
                        >
                            {years.map((y) => (
                                <MenuItem key={y.yearID} value={y.yearID}>{y.year}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Month"
                            value={filter.month}
                            onChange={handleMonthChange}
                            fullWidth
                            size="small"
                        >
                            {months.map((m) => (
                                <MenuItem key={m.month_no} value={m.month_no}>{m.month_name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Unit (optional)"
                            value={filter.unitID}
                            onChange={handleUnitChange}
                            fullWidth
                            size="small"
                        >
                            <MenuItem value="">All Units</MenuItem>
                            {units.map((u) => (
                                <MenuItem key={u.unitID} value={u.unitID}>{u.unitDescription}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ height: '100%' }}>
                            <Button variant="contained" onClick={loadData} fullWidth>Load</Button>
                        </Stack>
                    </Grid2>
                </Grid2>

                {isLoading ? <Loading /> : (
                    <>
                        <Typography sx={{ mb: 1, fontWeight: 700 }}>Eligible Loans (Approved, Balance > 0, Installments > 1)</Typography>
                        <TableDataWithPagination
                            tableColumns={eligibleColumns}
                            tableData={eligible}
                            editIcon="tune"
                            onEditClick={openDeductionControl}
                            onDeleteClick={() => { }}
                        />

                        <Box sx={{ mt: 4 }}>
                            <Typography sx={{ mb: 1, fontWeight: 700 }}>Saved Controls for Selected Month</Typography>
                            <TableDataWithPagination
                                tableColumns={skipColumns}
                                tableData={skipList}
                                onEditClick={() => { }}
                                onDeleteClick={onRemoveClick}
                            />
                        </Box>
                    </>
                )}
            </Container>
            <Dialog open={Boolean(selectedAdvance)} onClose={() => setSelectedAdvance(null)} fullWidth maxWidth="xs">
                <DialogTitle>Loan Deduction Control</DialogTitle>
                <DialogContent dividers>
                    <Typography sx={{ mb: 2 }}>{selectedAdvance?.empName} — Loan #{selectedAdvance?.advID}</Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>Regular monthly installment: {Number(selectedAdvance?.amount || 0) / Number(selectedAdvance?.installments || 1)}</Typography>
                    <TextField fullWidth size="small" type="number" label="Deduct this month" value={deductionAmount} inputProps={{ min: 0, max: Number(selectedAdvance?.amount || 0) / Number(selectedAdvance?.installments || 1), step: 0.01 }} onChange={(event) => setDeductionAmount(event.target.value)} helperText="Leave empty to skip the full installment." />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSelectedAdvance(null)}>Cancel</Button>
                    <Button color="warning" onClick={onSkipClick}>Skip Full Month</Button>
                    <Button variant="contained" disabled={Number(deductionAmount) <= 0} onClick={saveCustomDeduction}>Save Amount</Button>
                </DialogActions>
            </Dialog>
            <Footer />
        </>
    );
}
